import { Collection, RefBool, RefDate, RefString } from "@tblabs/truffle";
import { RawBlogArticle } from "./RawBlogArticle";
import { Field } from "../Description/Field";
import { GalleryItem } from "../Description/Gallery/GalleryItem";
import { DescriptionFieldConverter } from "../../Services/Content/DescriptionFieldConverter";
import { ArticleId } from "./ArticleId";


export class BlogArticle
{
    public Id: ArticleId = "";
    public Visible = new RefBool(true);
    public Category = new RefString();
    public Title = new RefString();
    public Subtitle = new RefString();
    public Url = new RefString();
    public PublishDate = new RefDate();
    public Content = new Collection<Field>();
    public Images = new Collection<GalleryItem>();
    
    constructor(raw: Partial<RawBlogArticle>)
    {
        this.Id = raw.Id as ArticleId || "";
        this.Visible.value = raw.Visible ?? true;
        this.Category.value = raw.Category || "";
        this.Title.value = raw.Title || "";
        this.Subtitle.value = raw.Subtitle || "";
        this.Url.value = raw.Url || "";
        this.PublishDate.value = new Date(raw.PublishDate || 0);
        this.Content.Load(...(raw?.Content?.map(x => DescriptionFieldConverter.ToClass(x)) || []));
        this.Images.Load(...(raw?.Images?.map(x => new GalleryItem(x)) || []));
    }

    public get IsNew(): boolean
    {
        return !!!+this.PublishDate.value;
    }
}
